//Lib
import { FieldType, ViewModelBase, ApiResult, autorun } from "@shoothill/core";
import { action, computed, observable, runInAction } from "mobx";
import validator from "validator";

// App
import { AppUrls } from "AppUrls";
import { StoresInstance } from "Globals/Stores";
import { SaveStore } from "Globals/Stores/Domain";

// Models
import { SupportingInformationDTO } from "Globals/Models/DTO/SupportingInformationDTO";
import { UserFile } from "Globals/Models/UserFile";
import { SupportingInformationModel } from "Globals/Models/Domain/FormSections/SupportingInformation/SupportingInformationModel";

// View models
import ParentSupportingInformationViewModel from "./ParentSupportingInformationViewModel";

export default class SupportingInformationViewModel extends ViewModelBase<SupportingInformationModel> {
    private saveStore: SaveStore = StoresInstance.Domain.SaveStore;

    constructor(parent: ParentSupportingInformationViewModel | null, supportingInformationModel?: SupportingInformationModel) {
        super(supportingInformationModel ? supportingInformationModel : new SupportingInformationModel());
        if (parent !== null) {
            console.log("Parent Supporting Length", parent.supportingInformationViewModels.length);
        }
        autorun(() => {
            console.log("SupportingInformationViewModel Id: ", this.model.id);
        });
    }

    @action
    public save = async (userFile: UserFile, parent: ParentSupportingInformationViewModel, isDeleted: boolean, skipPush: boolean = false): Promise<void> => {
        try {
            this.setIsLoading(true);
            this.saveStore.setIsSaving(true);
            console.log("Userfile: ", userFile);
            //const correctModel = parent.getUserFiles.find((x) => x.fileUrl === userFile.fileUrl);
            runInAction(() => {
                /*if (correctModel) {
                    this.model.id = correctModel.model.id;
                }*/
                this.model.id = userFile.id;
                this.model.formId = parent.model.formId;
                this.model.applicantId = parent.model.applicantId;
                this.model.documentTypeId = userFile.documentTypeId;
                this.model.fileName = userFile.fileName;
                this.model.documentUrl = userFile.fileUrl;
                this.model.isDeleted = isDeleted;
            });

            console.log("Saving Supporting Information: ", this.model);

            let upsertSupportingInformation: SupportingInformationDTO = this.model.toDto();
            const apiResult = await this.Post<SupportingInformationDTO>(AppUrls.Server.ApplicationForm.Upsert.SupportingInformation, upsertSupportingInformation);

            if (apiResult.wasSuccessful) {
                this.model.fromDto(apiResult.payload);
                console.info("SupportingInformation:Upsert-Successful");

                let model = new SupportingInformationModel();
                model.fromDto(apiResult.payload);
                let supportingInformationViewModel = new SupportingInformationViewModel(null, model);

                runInAction(() => {
                    if (isDeleted) {
                        const index = parent.supportingInformationViewModels.indexOf(supportingInformationViewModel);
                        if (index > -1) {
                            parent.supportingInformationViewModels.splice(index, 1);
                        }
                    } else {
                        if (!skipPush) {
                            console.log("Push file.");
                            parent.supportingInformationViewModels.push(supportingInformationViewModel);
                        }
                    }
                });

                parent.handleInputChange();

                return Promise.resolve();
            } else {
                console.error("SupportingInformation:Upsert-Error", apiResult.errors);
                return Promise.reject(apiResult.errors);
            }
        } catch (exception) {
            console.error(exception);
        } finally {
            this.saveStore.setIsSaving(false);
            this.setIsLoading(false);
        }
    };

    public async isFieldValid(fieldName: keyof FieldType<SupportingInformationModel>, value: any): Promise<boolean> {
        // let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        // this.setError(fieldName, errorMessage);
        // this.setValid(fieldName, isValid);

        // return isValid;

        return await this.isValid(fieldName, value);
    }

    public async isValid(fieldName: keyof FieldType<SupportingInformationModel>, value: any, isRequired: boolean = false): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);
        if (fieldName == "documentTypeId") {
            if ((value === "" || value === null || value === undefined) && isRequired) {
                errorMessage = "required to proceed";
                isValid = false;
            }
        }
        if (!isValid) {
            console.log("Field Not valid: ", fieldName);
        }
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);
        return isValid;
    }

    /**
     * @returns boolean does this section have any errors
     */
    @action
    public async showUnfinishedFields(): Promise<boolean> {
        let hasError = false;
        for (const _field of Object.keys(this.model)) {
            let field = _field as keyof FieldType<SupportingInformationModel>;
            let value = this.model.getValue(field);
            let isRequired = true;
            let isValid = await this.isValid(field, value, isRequired);
            if (!isValid) {
                hasError = true;
            }
        }
        return hasError;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
